._ErrorTrace_1x3to_1 {
  white-space: pre-wrap;
}